import React from 'react'

import { WrapperStyle, WrapperLastStyle } from './BlockContainer.styles'

interface BlockContainerProps {
  children?: React.ReactNode
  isLast: boolean
}

export const BlockContainer = (props: BlockContainerProps) => {
  return <view style={props.isLast ? WrapperLastStyle : WrapperStyle}>{props.children}</view>
}
